import React from 'react';
import { ProductOrderUploadTemplate } from 'themes/application/product/pages';
import { observer } from 'mobx-react';
import { ProductOrderUploadViewStore } from 'application/product/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductOrderUploadViewStore(rootStore), 'productOrderUploadViewStore')
@observer
class ProductOrderUpload extends React.Component {
    render() {
        return <ProductOrderUploadTemplate {...this.props} />
    }
}

export default ProductOrderUpload;